<template>
	<a :href="url" :target="target">
		<v-list-item @click="$emit('click')">
			<v-list-item-avatar>
				<v-icon :color="icon == 'mdi-link' ? 'secondary' : 'blue'">{{ icon }}</v-icon>
			</v-list-item-avatar>
			<v-list-item-content>
				<v-list-item-title v-text="title" class="text-wrap" />
				<v-list-item-subtitle v-if='!hideUrl' v-text="url" />
			</v-list-item-content>
		</v-list-item>
	</a>
</template>

<script>
export default {
	name: 'LinkItem',
	props: {
		title: String,
		url: String,
		icon: {
			type: String,
			default: 'mdi-link'
		},
		hideUrl: Boolean,
		target: String
	},
}
</script>

<style lang="scss" scoped>
a {
	text-decoration: none;
}
</style>